import { render, staticRenderFns } from "./InternalTransferModal.vue?vue&type=template&id=b7c33dfc&scoped=true&"
import script from "./InternalTransferModal.vue?vue&type=script&lang=js&"
export * from "./InternalTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./InternalTransferModal.vue?vue&type=style&index=0&id=b7c33dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c33dfc",
  null
  
)

export default component.exports